const countriesList = ['usa', 'us', 'ca', 'canada']
const isUsaCanadaOrBlank = (country = '') =>
  country ? countriesList.includes(country?.toLowerCase()) : true

export default isUsaCanadaOrBlank
